module.exports = __webpack_public_path__ + "img/header-weddingRingsStackingRings.bff0258.jpg";